// Mirrors Duende IdentityServer's TokenExpiration enum.
export enum RefreshTokenExpiration {
    Sliding = 0,
    Absolute = 1,
}

export interface ConfidentialClientClaimViewModel {
    type: string;
    value: string;
}

export interface ConfidentialClientViewModel {
    clientId: string;
    clientName: string;
    allowedGrantTypes: string[];
    allowedScopes: string[];
    redirectUris: string[];
    postLogoutRedirectUris: string[];
    allowedCorsOrigins: string[];
    accessTokenLifetime: number;
    refreshTokenExpiration: RefreshTokenExpiration;
    absoluteRefreshTokenLifetime: number;
    slidingRefreshTokenLifetime: number;
    requirePkce: boolean;
    requireClientSecret: boolean;
    allowOfflineAccess: boolean;
    requireConsent: boolean;
    allowAccessTokensViaBrowser: boolean;
    hasSecret: boolean;
    claims: ConfidentialClientClaimViewModel[];
}

export interface CreateConfidentialClientRequest {
    clientName: string;
    allowedGrantTypes: string[];
    allowedScopes: string[];
    redirectUris: string[];
    postLogoutRedirectUris: string[];
    allowedCorsOrigins: string[];
    accessTokenLifetime: number;
    refreshTokenExpiration: RefreshTokenExpiration;
    absoluteRefreshTokenLifetime: number;
    // Only used under Sliding expiration; omitted otherwise so the server keeps the stored value.
    slidingRefreshTokenLifetime?: number;
    requirePkce: boolean;
    requireClientSecret: boolean;
    allowOfflineAccess: boolean;
    requireConsent: boolean;
    allowAccessTokensViaBrowser: boolean;
    secret?: string;
    secretDescription?: string;
    claims: ConfidentialClientClaimViewModel[];
}

export interface UpdateConfidentialClientRequest {
    allowedScopes: string[];
    redirectUris: string[];
    postLogoutRedirectUris: string[];
    allowedCorsOrigins: string[];
    accessTokenLifetime: number;
    refreshTokenExpiration: RefreshTokenExpiration;
    absoluteRefreshTokenLifetime: number;
    // Only used under Sliding expiration; omitted otherwise so the server keeps the stored value.
    slidingRefreshTokenLifetime?: number;
    claims: ConfidentialClientClaimViewModel[];
}
